var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M1993 1334l-1625 0c-35,0 -64,-29 -64,-64 0,-35 29,-63 64,-63l1625 0 -456 -456c-25,-25 -25,-65 0,-90 25,-24 65,-24 90,0l609 609 -609 609c-25,24 -65,24 -90,0 -25,-25 -25,-65 0,-90l456 -455z"})));
}

Next.defaultProps = {"height":"100px","width":"100px","version":"1.1","viewBox":"0 0 2540 2540","x":"0px","y":"0px"};

module.exports = Next;

Next.default = Next;
